window.supportedBrowser = function () {
  const isChromeIos = /CriOS/.test(navigator.userAgent);
  const isSafari = /Version\/[\d.]+.*Safari/.test(navigator.userAgent);
  return (window.chrome || isChromeIos || isSafari || navigator.webdriver) && !/Edge/.test(navigator.userAgent);
};

if (!window.supportedBrowser()) {
  const thankYouPathMatch = new RegExp(/thankyou-for-registering(\?.*)/g).exec(window.location);
  const setPasswordPathMatch = new RegExp(/change-password(\?.*)/g).exec(window.location);

  if (thankYouPathMatch) {
    window.location = `./no-ng/thank-you-for-registering.html${thankYouPathMatch[1]}`;
  } else if (setPasswordPathMatch) {
    window.location = `./no-ng/set-password.html${setPasswordPathMatch[1]}`;
  } else {
    window.location = './no-ng/unsupported.html';
  }
}

localStorage.debug = 'PEEK:*';

// Google Analytics v4

function loadGA(propertyId) {
  const s = document.createElement('script');
  s.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${propertyId}`);
  s.async = true;
  document.body.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    dataLayer.push(arguments);
  };
  gtag('js', new Date());
  gtag('config', propertyId, { send_page_view: false });
}

const TESTENV = /test|uat|demo|regression|preprod|0.0.0.0|localhost|127.0.0.1/.test(location.hostname);

const ADMIN_GA_PROPERTIES = {
  TEST: 'G-SDGGE3BYSJ',
  LIVE: 'G-XR51DV2D91',
};

window.peekGaPropertyId = TESTENV ? ADMIN_GA_PROPERTIES.TEST : ADMIN_GA_PROPERTIES.LIVE;

loadGA(window.peekGaPropertyId);
